// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.review-tab-container {
  display: flex;
  flex-direction: column;
  /* padding: 16px 24px 16px 24px; */
  background-color: #fff;
  overflow: hidden;
  height: 100%;
  padding: 12px 0px 0px 0px;
}

.review-tab-container .main-content {
  display: flex;
  flex-direction: row;
  gap: 24px;
  flex: 1;
  overflow-y: auto;
  max-height: 676px;
}

.review-tab-container .main-content .contravention-snapshot-section {
  flex: 2.5;
  padding: 0; /* padding moved inside component */
  background: transparent;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.review-tab-container .main-content .case-details-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 396px;
  height: 100%;
}

.review-tab-container .main-content .case-details-header {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 8px;
  color: var(--ceoTrackTitleColor);
  user-select: none;
}

.review-tab-container .main-content .vrm-details-section {
  flex: 1;
  padding: 16px;
  background: #fff;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--placeHolderColor, #d0d0d0);
  border-radius: 16px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--scrollBarBgColor) transparent;
}

.review-tab-container .main-content .vrm-details-section::-webkit-scrollbar {
  width: 4px;
}

.review-tab-container
  .main-content
  .vrm-details-section::-webkit-scrollbar-track {
  background: transparent;
}

.review-tab-container
  .main-content
  .vrm-details-section::-webkit-scrollbar-thumb {
  background-color: var(--scrollBarBgColor);
  border-radius: 4px;
}

.review-tab-container
  .main-content
  .vrm-details-section::-webkit-scrollbar-thumb:hover {
  background-color: var(--scrollBarBorderColor);
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/manualReviewTab/features/reviewTab/ReviewTab.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU,EAAE,mCAAmC;EAC/C,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kDAAkD;EAClD,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;;;EAGE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;;;EAGE,6CAA6C;AAC/C","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.review-tab-container {\n  display: flex;\n  flex-direction: column;\n  /* padding: 16px 24px 16px 24px; */\n  background-color: #fff;\n  overflow: hidden;\n  height: 100%;\n  padding: 12px 0px 0px 0px;\n}\n\n.review-tab-container .main-content {\n  display: flex;\n  flex-direction: row;\n  gap: 24px;\n  flex: 1;\n  overflow-y: auto;\n  max-height: 676px;\n}\n\n.review-tab-container .main-content .contravention-snapshot-section {\n  flex: 2.5;\n  padding: 0; /* padding moved inside component */\n  background: transparent;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.review-tab-container .main-content .case-details-wrapper {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  max-width: 396px;\n  height: 100%;\n}\n\n.review-tab-container .main-content .case-details-header {\n  font-weight: 600;\n  font-size: 16px;\n  margin-bottom: 8px;\n  color: var(--ceoTrackTitleColor);\n  user-select: none;\n}\n\n.review-tab-container .main-content .vrm-details-section {\n  flex: 1;\n  padding: 16px;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--placeHolderColor, #d0d0d0);\n  border-radius: 16px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: var(--scrollBarBgColor) transparent;\n}\n\n.review-tab-container .main-content .vrm-details-section::-webkit-scrollbar {\n  width: 4px;\n}\n\n.review-tab-container\n  .main-content\n  .vrm-details-section::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.review-tab-container\n  .main-content\n  .vrm-details-section::-webkit-scrollbar-thumb {\n  background-color: var(--scrollBarBgColor);\n  border-radius: 4px;\n}\n\n.review-tab-container\n  .main-content\n  .vrm-details-section::-webkit-scrollbar-thumb:hover {\n  background-color: var(--scrollBarBorderColor);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
